import { httpMethod, useApi } from './useApi';
import { isNonEmpty } from '../utils/arrayUtils';
export const useGetDocuments = ({ document_ids, types }) => {
    let queryParameters = {};
    if (isNonEmpty(document_ids)) {
        queryParameters['ids'] = document_ids;
    }
    if (isNonEmpty(types)) {
        queryParameters['types'] = types;
    }
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'documents',
        httpMethod: httpMethod.GET,
        body: {},
        queryParams: queryParameters,
    });
    const responseData = data;
    return { call, data: responseData, error, ...rest };
};
export const useCreatePDF = () => {
    const { call, data, ...rest } = useApi({
        authenticated: true,
        path: 'pdfs',
        httpMethod: httpMethod.POST,
    });
    const responseData = data;
    return { call, data: responseData, ...rest };
};
export const useDeleteDocuments = () => {
    const { call, data, ...rest } = useApi({
        authenticated: true,
        path: 'documents',
        httpMethod: httpMethod.DELETE,
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, ...rest };
};
export const useFillDocument = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'document-filling',
        httpMethod: httpMethod.POST,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
export const useExtractTargets = () => {
    const { call, data, error, ...rest } = useApi({
        authenticated: true,
        path: 'targets',
        httpMethod: httpMethod.POST,
        body: {},
    });
    const callFunction = (body) => {
        call(body);
    };
    const responseData = data;
    return { call: callFunction, data: responseData, error, ...rest };
};
